import React from 'react';
import { Box, Container, Heading, Stack, Button } from '@hover/blueprint';
import { iMapPin, iUsers } from '@hover/icons';
import { ArrowButton } from '@hover/shared-components';
import JobPostBadge from './JobPostBadge';

interface Props {
  title: string;
  office: string;
  department: string;
}

const Hero: React.FC<Props> = ({ title, office, department }) => {
  const onApplyNow = () => {
    const formElement = document.getElementById('job-post-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <Box
      w="100%"
      bg="brandTan.200"
      pt={{ base: 600, tablet: 800 }}
      pb={{ base: 600, tablet: '56px' }}
      alignItems="center"
    >
      <Container
        px={500}
        d="flex"
        maxW="1200px"
        flexDir="column"
        alignItems={{ base: 'center', desktop: 'flex-start' }}
      >
        <Box d={{ base: 'none', tablet: 'flex' }} mb={400}>
          <JobPostBadge mr={600} bg="neutral.0" icon={iMapPin} title={office} />
          <JobPostBadge bg="neutral.0" icon={iUsers} title={department} />
        </Box>
        <Heading
          textAlign={{ base: 'center', tablet: 'left' }}
          marginBottom={{ base: 600, tablet: 800 }}
          size={{ base: 500, tablet: 600, desktop: 700 }}
          color={{ base: 'brandNavy.500', tablet: 'neutral.700' }}
          isLight
        >
          {title}
        </Heading>
        <Stack
          direction={{ base: 'column', tablet: 'row' }}
          spacing={{ base: 400, tablet: 500 }}
          w="100%"
          alignItems="center"
          justifyContent={{ base: 'center', desktop: 'flex-start' }}
        >
          <Button
            onClick={onApplyNow}
            size="large"
            w={{ base: '100%', tablet: 'auto' }}
            fontSize="14px"
          >
            APPLY NOW
          </Button>
          <ArrowButton
            as="a"
            href="/careers#open-roles"
            variant="minimal"
            w={{ base: '100%', tablet: 'auto' }}
            sx={{
              // TODO(buttons): remove when we remove padding in Blueprint
              div: { pl: 0, pr: 50 },
            }}
          >
            Back to open roles
          </ArrowButton>
        </Stack>
      </Container>
    </Box>
  );
};

export default Hero;
